import { type NavigationError } from "@angular/router";

const CHUNK_LOAD_ERROR_MESSAGES = [
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "error loading dynamically imported module",
];

const RELOAD_AT_KEY = "oct-chunk-load-reload-at";
const RELOAD_COOLDOWN_MS = 60000;

function isChunkLoadError(error: unknown) {
  return (
    error instanceof TypeError &&
    CHUNK_LOAD_ERROR_MESSAGES.some(message => error.message.includes(message))
  );
}

function reloadedRecently() {
  try {
    const lastReloadAt = Number(
      window.sessionStorage.getItem(RELOAD_AT_KEY) ?? "0"
    );
    const elapsed = Date.now() - lastReloadAt;

    return (
      Number.isFinite(lastReloadAt) &&
      elapsed >= 0 &&
      elapsed < RELOAD_COOLDOWN_MS
    );
  } catch {
    return true;
  }
}

function reloadForChunkLoadError(error: unknown, targetUrl: string) {
  if (!isChunkLoadError(error) || reloadedRecently()) return;

  try {
    window.sessionStorage.setItem(RELOAD_AT_KEY, Date.now().toString());
  } catch {
    return;
  }

  window.location.assign(targetUrl);
}

export function recoverFromChunkLoadError(navigationError: NavigationError) {
  reloadForChunkLoadError(navigationError.error, navigationError.url);
}

export function installChunkLoadErrorRecovery() {
  window.addEventListener("error", event => {
    reloadForChunkLoadError(event.error, window.location.href);
  });

  window.addEventListener("unhandledrejection", event => {
    reloadForChunkLoadError(event.reason, window.location.href);
  });
}
